import PatientOverviewPAGoalSetting from 'dashboard/templates/views/Patient/PA/PatientOverviewPAGoalSetting';

import weeklySportsGoal from './weekly-sports-goal';
import dailyActivityGoal from './daily-activity-goal';
import strengthTraining from './strength-training';

/**
 * Start moving Goal setting routes
 * @name router.Start-moving-Goal-setting
 */

export default {
  path: 'goal-setting',
  component: PatientOverviewPAGoalSetting,
  name: 'PatientRecordPAGoalSetting',
  redirect: { name: 'PatientRecordPAGoalSettingWeeklySportsGoal' },
  meta: {
    // title: 'Patient Record - Physical Activity - Goal Setting',
    title: t => `${t('patient.patientRecord')} - ${t('screens.startMovingSettingsScreen', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
    loggedInOnly: true,
  },
  children: [
    weeklySportsGoal,
    dailyActivityGoal,
    // Note: Release 2.0 scope reduction
    // strengthTraining,
  ],
};
